import { CascadiaColor, CascadiaStandardIcon } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import React, { KeyboardEvent, cloneElement, useRef } from "react";

import { Icon } from "../../foundations/icons/Icon/Icon";

interface LegacyMenuItemProps extends React.HTMLAttributes<HTMLLIElement> {
  children: React.ReactElement;
  itemKey?: string;
  icon?: CascadiaStandardIcon;
  iconColor?: CascadiaColor;
  onPress?: (event: KeyboardEvent<HTMLLIElement>) => void;
  isContainNestedMenu?: boolean;
  testID?: string;
}

/**
 * @deprecated see MenuItem
 */
export function LegacyMenuItem(props: LegacyMenuItemProps) {
  const {
    children,
    icon,
    onPress,
    isContainNestedMenu,
    testID = "menu-item",
    itemKey = "",
    iconColor,
    ...rest
  } = props;
  const menuItemRef = useRef(null);
  const listItemProps = {
    ref: menuItemRef,
    tabIndex: 0,
  };

  const childProps = {
    role: "menuitem",
    "aria-haspopup": isContainNestedMenu,
    dataKey: itemKey,
  };

  return (
    <li
      role="menuitem"
      className={css(styles.menuItem, {
        "&:hover": css({
          background: "var(--background-selected-weak)",
          cursor: "pointer",
        }),

        "&:focus": css({
          background: "var(--background-selected-weak)",
          outline: "none",
        }),
      })}
      {...listItemProps}
      {...rest}
      onKeyDown={onPress}
      data-testid={testID}
      data-key={itemKey}
    >
      {icon && (
        <div className={styles.iconWrapper}>
          <Icon
            color={iconColor ?? "icon-base"}
            padding="space-05"
            name={icon}
          />
        </div>
      )}
      {cloneElement(children, childProps)}
    </li>
  );
}

const styles = {
  menuSectionDivider: css({
    "&:first-child": css({
      display: "none",
    }),
  }),
  list: css({
    padding: 0,
    margin: 0,
    listStyleType: "none",
  }),
  header: css({
    padding: "var(--space-4)",
    "& p, h2": css({
      margin: 0,
    }),
  }),
  relativeWrapper: css({
    position: "relative",
  }),
  iconWrapper: css({
    display: "flex",
    alignItems: "center",
    marginRight: "var(--space-2-5)",
  }),
  menuItem: css({
    padding: `${"var(--space-2)"} ${"var(--space-3)"}`,
    marginLeft: "var(--space-1)",
    marginRight: "var(--space-1)",
    display: "flex",
    alignItems: "center",
    borderRadius: "var(--border-radius-2)",
    "&:hover": css({
      cursor: "pointer",
    }),
    "&:focus": css({
      outline: "none",
    }),
  }),
  sectionHeader: css({
    padding: `${"var(--space-05)"} ${"var(--space-4)"}`,
    marginBottom: "var(--space-1)",
    display: "inline-block",
  }),
  actionArea: css({
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-1)",
  }),
};
